module.exports = __webpack_public_path__ + "img/ic_memo_talk.14c10794.svg";